export * from './ConsultaNFServiceAdapter'